import store from '../store'

export const isAuthenticated = (to, from, next) => {
  if (store.getters.profileLoaded) {
    return next()
  }
  next('/admin/login')
}